export default "__VITE_ASSET__DaQY81UA__"